const prefix = '@retailMedia/industry/publisherConfiguration'

export const PUBLISHER_CONFIGURATION_LIST = `${prefix}/LIST`

export const types = {
  list: PUBLISHER_CONFIGURATION_LIST,
  listDestinationUrls: `${prefix}/LIST_DESTINATION_URLS`
}
